module.exports = __webpack_public_path__ + "static/media/stat.92fa4a13.svg";